<form [formGroup]="formProtocol" (ngSubmit)="onSubmit($event)" *ngIf="formProtocol">
  <div>
    <div class="row">
      <!-- <div comboModInput class="col-sm-4" [labelInput]="'Classe'" [mandatory]="true"
        [control]="formProtocol.controls['classe']"
        formControlName="classe" [objectReference]="formProtocol.get('classe').value"
        (onReturn)="formProtocol.get('classe').setValue($event)" [optionsCombo]="tipoDocumentoOption">
      </div> -->
      <div textAreaInput [control]="formProtocol.controls['object']" class="col-sm-12 pl-15" [labelInput]="'Oggetto'"
        [mandatory]="true" formControlName="object">
      </div>
    </div>
    <div class="col-sm-12 pl-15 mt-5">
      <small role="alert">
        <span *ngIf="remainingChars >= 0">
          {{ formProtocol.controls['object'].value?.length || 0 }} / 250 caratteri
        </span>
        <span *ngIf="remainingChars < 0" class="text-danger">
          Hai superato il limite di {{ -remainingChars }} caratteri (max 250).
        </span>
      </small>
    </div>
    <hr style="visibility: hidden;">
    <div class="row">
      <div class="col-sm-4 pl-15">
        <div checkBoxRadio [idInput]="'arrivoPartenza' + randomId" formControlName="arrivoPartenza" [mandatory]="true"
          [labelInput]="'Registrazione'" [labelNotChecked]="'in entrata'" [labelChecked]="'in uscita'"
          [objectReference]="formProtocol.get('arrivoPartenza').value" [control]="formProtocol.controls['arrivoPartenza']"
          (onReturn)="formProtocol.get('arrivoPartenza').setValue($event)">
        </div>
      </div>
      <div singleCheckBoxModInput class="col-sm-4" [labelInput]="'Nota riservata'"
        (onReturn)="formProtocol.get('notaRiservata').setValue($event); onFlagNotaRiservataChange($event)"
        [objectReference]="formProtocol.get('notaRiservata').value"  [idInput]="notaRiservata">
      </div>
      <div singleCheckBoxModInput class="col-sm-4" [labelInput]="'Dati sensibili'"
        (onReturn)="formProtocol.get('datiSensibili').setValue($event); onFlagDatiSensibiliChange($event)"
        [objectReference]="formProtocol.get('datiSensibili').value"  [idInput]="datiSensibili">
      </div>
    </div>
  </div>
  <ng-container *ngIf="formProtocol.get('arrivoPartenza').value != null">
    <div style="margin-top: 10px"></div>
    <fieldset>
      <legend>{{ formProtocol.get('arrivoPartenza').value ? "Destinatari" : "Mittente" }}<span
          class="mandatory">*</span> <small class="sr-only">Protocollo</small> </legend>
      <div class="form-row">
        <p class="mandatory col-sm-12">
          <em *ngIf="formProtocol.get('arrivoPartenza').value; else mittente">
            * Inserire almeno un destinatario tra tipo persona o ufficio
          </em>
          <ng-template #mittente>
            <em>* E' obbligatorio selezionare un mittente (persona fisica o giuridica) e indicare un destinatario come Ufficio interno</em>
          </ng-template>
        </p>
      </div>
      <ng-container  *ngIf="!formProtocol.get('arrivoPartenza').value;">
        <div class="form-row">
        <div comboModInput class="col-sm-3" formControlName="typeSenderReceiver" [labelInput]="'Tipo Persona'"
          [optionsCombo]="persons" [control]="formProtocol.controls['typeSenderReceiver']" [mandatory]="false"
          [labelOption]="'label'" [objectReference]="formProtocol.get('typeSenderReceiver').value" [disabledSelect]="isTypeSenderReceiverDisabled() ? true : null"
          (onReturn)="formProtocol.get('typeSenderReceiver').setValue($event);changeTipoPersona($event)">
        </div>
        <form [formGroup]="formProtocol">
          <ng-container *ngIf="formProtocol.get('typeSenderReceiver').value?.label === 'GIURIDICA'">
            <div formGroupName="senderReceiver">
              <div textInput class="col-sm-4" [labelInput]="'Denominazione'" formControlName="denomination"
                [mandatory]="true">
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="formProtocol.get('typeSenderReceiver').value?.label === 'FISICA'">
            <div formGroupName="senderReceiver">
              <div textInput class="col-sm-3" [labelInput]="'Nome'" formControlName="firstName" [checkFormat]="true"
                [mandatory]="true"></div>
              <div textInput class="col-sm-3" formControlName="lastName" [autocomplete]="'family-name'" [checkFormat]="true" [mandatory]="true"
                [labelInput]="'Cognome'"></div>
              <div textInput class="col-sm-3" [labelInput]="'Codice fiscale'" [maxLength]="'16'" [checkFormat]="true"
                [control]="formProtocol.get('senderReceiver').controls['taxNumber']" formControlName="taxNumber">
              </div>
            </div>
          </ng-container>
        </form>
        </div>
        <ng-container *ngIf="formProtocol.get('typeSenderReceiver').value?.label !== null && !!senderList && ((formProtocol.get('arrivoPartenza').value) || showAddMittenteDestinatarioButton() )">
          <div class="form-row">
            <div class="col-sm-9"></div>
            <button class="btn btn-primary col-xs-12 col-sm-3 bottom-insert" type="button"
              [disabled]="!formProtocol.get('senderReceiver').valid" (click)="addMittenteDestinatario()">Aggiungi {{
              formProtocol.get('arrivoPartenza').value ? "Destinatario" : "Mittente" }}</button>
          </div>
        </ng-container>
    </ng-container>
      <div class="form-row" *ngIf="formProtocol.get('arrivoPartenza').value;">
        <div class="col-sm-6" >
          <div class="form-group" style="margin-bottom: 20px;">
            <label>Seleziona Uffic{{formProtocol.get('arrivoPartenza').value ? "i" : "io"}}</label>
            <ng-multiselect-dropdown
              #multiSelect
              [automaticSearch]="false"
              [formControl]="formProtocol.get('codeOfficeList')"
              [placeholder]="'Seleziona'"
              [settings]="settingsDestinatario"
              (onFilterChange)="filterUffici($event)"
              [data]="ufficiOptions"
              (onSelect)="onItemSelect($event)"
              (onDeSelect)="onItemDeSelect($event)">
            </ng-multiselect-dropdown>


            <!-- <p-multiSelect class="multiSelect" display="chip" optionValue="id" [options]="ufficiOptions" optionLabel="descrizione" formControlName="codeOfficeList"
                           (onChange)="onMultySelect({key: 'codeOfficeList', event: $event})" [showClear]="true"
                           [filter]="true" (onFilter)="filterUffici($event)" placeholder="Seleziona Uffici">
            </p-multiSelect> -->
          </div>
        </div>
        <div *ngIf="ufficiError" class="col-sm-6 alert alert-danger" style="margin-top: 2%;">
              {{ ufficiError }}
        </div>
        <ng-container *ngIf="showAddUfficioButton()">
          <div class="form-row">
            <div class="col-sm-9"></div>
            <button class="btn btn-primary col-xs-12 col-sm-3 bottom-insert" type="button"
              [disabled]="!formProtocol.get('codeOfficeList').valid" (click)="addUfficio()">Aggiungi Ufficio</button>
          </div>
        </ng-container>
      </div>
      <div class="separator"></div>
      <div class="form-row" *ngIf="!formProtocol.get('arrivoPartenza').value;">
        <div class="col-sm-6" >
          <div class="form-group" style="margin-bottom: 20px;">
            <label>Seleziona Uffic{{formProtocol.get('arrivoPartenza').value ? "i" : "io"}}</label>
            <ng-multiselect-dropdown
              #multiSelect
              *ngIf="!formProtocol.get('arrivoPartenza').value;"
              [automaticSearch]="false"
              [formControl]="formProtocol.get('codeOfficeList')"
              [placeholder]="'Seleziona'"
              [settings]="settingsMittente"
              (onFilterChange)="filterUffici($event)"
              [data]="ufficiOptions"
              (onSelect)="onItemSelect($event)"
              (onDeSelect)="onItemDeSelect($event)"
              [disabled]="isDropdownDisabled()">
            </ng-multiselect-dropdown>
      </div>
      </div>
      <ng-container *ngIf="showAddUfficioButton()">
        <div class="form-row">
          <div class="col-sm-9"></div>
          <button class="btn btn-primary col-xs-12 col-sm-3 bottom-insert" type="button"
            [disabled]="!formProtocol.get('codeOfficeList').valid" (click)="addUfficio()">Aggiungi Ufficio</button>
        </div>
      </ng-container>
      </div>
      <ng-container  *ngIf="formProtocol.get('arrivoPartenza').value;">
        <div class="form-row">
        <div comboModInput class="col-sm-3" formControlName="typeSenderReceiver" [labelInput]="'Tipo Persona'"
          [optionsCombo]="persons" [control]="formProtocol.controls['typeSenderReceiver']" [mandatory]="false"
          [labelOption]="'label'" [objectReference]="formProtocol.get('typeSenderReceiver').value" [attr.disabled]="isTypeSenderReceiverDisabled() ? true : null"
          (onReturn)="formProtocol.get('typeSenderReceiver').setValue($event);changeTipoPersona($event)">
        </div>
        <form [formGroup]="formProtocol">
          <ng-container *ngIf="formProtocol.get('typeSenderReceiver').value?.label === 'GIURIDICA'">
            <div formGroupName="senderReceiver">
              <div textInput class="col-sm-4" [labelInput]="'Denominazione'" formControlName="denomination"
                [mandatory]="true">
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="formProtocol.get('typeSenderReceiver').value?.label === 'FISICA'">
            <div formGroupName="senderReceiver">
              <div textInput class="col-sm-3" [labelInput]="'Nome'" formControlName="firstName" [checkFormat]="true"
                [mandatory]="true"></div>
              <div textInput class="col-sm-3" formControlName="lastName" [autocomplete]="'family-name'" [checkFormat]="true" [mandatory]="true"
                [labelInput]="'Cognome'"></div>
              <div textInput class="col-sm-3" [labelInput]="'Codice fiscale'" [maxLength]="'16'" [checkFormat]="true"
                [control]="formProtocol.get('senderReceiver').controls['taxNumber']" formControlName="taxNumber">
              </div>
            </div>
          </ng-container>
        </form>
      </div>
    </ng-container>
      <ng-container *ngIf="formProtocol.get('arrivoPartenza').value && formProtocol.get('typeSenderReceiver').value?.label !== null && !!senderList && ((formProtocol.get('arrivoPartenza').value) || showAddMittenteDestinatarioButton() )">
        <div class="form-row">
          <div class="col-sm-9"></div>
          <button class="btn btn-primary col-xs-12 col-sm-3 bottom-insert" type="button"
            [disabled]="!formProtocol.get('senderReceiver').valid" (click)="addMittenteDestinatario()">Aggiungi {{
            formProtocol.get('arrivoPartenza').value ? "Destinatario" : "Mittente" }}</button>
        </div>
      </ng-container>
      <div class="separator" *ngIf="checkSenderList()"></div>
      <div class="form-row my-15">

        <table *ngIf="checkSenderList()" class="table-striped table col-xs-12">
          <caption class="sr-only">Tabella mittenti</caption>
          <tbody>
            <tr>
              <th colspan="4"> Tipologia Destinatario </th>
              <th colspan="4"> Nome </th>
              <th colspan="4"> Cognome </th>
              <th colspan="4"> Denominazione</th>
              <!-- <th colspan="4"> Uffici </th> -->
              <th colspan="3"> Codice Fiscale</th>
              <th colspan="3" *ngIf="formProtocol.get('arrivoPartenza').value"> Per conoscenza</th>
              <th colspan="1"></th>
            </tr>
            <ng-template ngFor let-sender [ngForOf]="senderList" let-senderPos=index>
              <tr *ngIf="!sender.offices">
                <td colspan="4">{{ sender.type === 'FISICA' ? 'Persona Fisica' : 'Persona Giuridica'}}</td>
                <td [ngClass]="sender.edit && sender.type === 'FISICA' ? 'edit-cell' : ''"
                    [attr.contenteditable]="sender.edit && sender.type === 'FISICA'"
                    (focusout)="onEditCell({event:$event.target.innerText, index: senderPos, type: 'firstName'})"
                    colspan="4">{{ sender.firstName }}</td>
                <td [ngClass]="sender.edit && sender.type === 'FISICA' ? 'edit-cell' : ''"
                    [attr.contenteditable]="sender.edit && sender.type === 'FISICA'"
                    (focusout)="onEditCell({event:$event.target.innerText, index: senderPos, type: 'lastName'})"
                    colspan="4">{{ sender.lastName }}</td>
                <td [ngClass]="sender.edit && sender.type === 'GIURIDICA' ? 'edit-cell' : ''"
                    [attr.contenteditable]="sender.edit && sender.type === 'GIURIDICA'"
                    (focusout)="onEditCell({event:$event.target.innerText, index: senderPos, type: 'denomination'})"
                    colspan="4">{{ sender.denomination }}</td>
                <td [ngClass]="sender.edit && sender.type === 'FISICA' ? 'edit-cell' : ''"
                    [attr.contenteditable]="sender.edit && sender.type === 'FISICA'"
                    (focusout)="onEditCell({event:$event.target.innerText, index: senderPos, type: 'taxNumber'})"
                    colspan="3">{{ sender.taxNumber }}</td>
                <td *ngIf="formProtocol.get('arrivoPartenza').value">
                  <div singleCheckBoxModInput class="col-sm-4"
                    (onReturn)="sender.inConoscenza = $event;"
                    [objectReference]="sender.inConoscenza"
                    (change)="onForConoscenzaChange(sender, senderPos)">
                  </div>
                </td>
                <td>
                  <a href="javascript:void(0);" title="modifica" aria-label="modifica" (click)="edit(senderPos)">
                    <span class="glyphicon" [ngClass]="sender.edit ? 'glyphicon-floppy-disk green' : 'glyphicon-pencil'"></span>
                  </a>
                  <a href="javascript:void(0);" title="elimina" aria-label="elimina" (click)="deleteSender(senderPos)">
                    <span class="glyphicon glyphicon-trash"></span>
                  </a>
                </td>
              </tr>
              <ng-container *ngIf="sender.offices && sender.offices.length > 0">
                <ng-container *ngFor="let office of sender.offices; let index = index">
                  <tr>
                    <td colspan="4">Ufficio</td>
                    <td colspan="4"></td>
                    <td colspan="4"></td>
                    <td colspan="4">{{ office.label }}</td>
                    <td colspan="3"></td>
                    <td *ngIf="formProtocol.get('arrivoPartenza').value">
                      <div singleCheckBoxModInput class="col-sm-4"
                        (onReturn)="office.inConoscenza = $event;"
                        [objectReference]="office.inConoscenza"
                        (change)="onForConoscenzaOfficeChange(senderPos, index)">
                      </div>
                    </td>
                    <td>
                      <a style="margin-left:35%" href="javascript:void(0);" title="elimina" aria-label="elimina" (click)="deleteOffice(senderPos,index)">
                        <span class="glyphicon glyphicon-trash"></span>
                      </a>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-template>
          </tbody>
        </table>
      </div>
    </fieldset>
  </ng-container>
  <div *ngIf="!isDocumentInserted" style="margin-top: 20px">
    <div class="row">
      <div class="col-sm-9" style="padding-left: 15px;">
        <div class="row" style="margin-top: 20px;margin-bottom: 10px;">
          <div class="col-sm-12">
            <div *ngIf="fileUploadList && fileUploadList.length > 0">
              <div *ngFor="let item of fileUploadList; let index = index">
                <app-document-uploaded 
                  [indexFile]="index" 
                  [tipiDocumentoOptions]="tipoDocumentoOption" 
                  (onReturn)="onDocReturn($event)"
                  (onExtract)="onExtractArchive($event)"
                  [protocol]="true"
                  (onRemoveFile)="deleteFile($event.refDocumentale, index)" 
                  [file]="item">
                </app-document-uploaded>
              </div>
            </div>
            <!-- <table class="tg" *ngIf="fileUploadList && fileUploadList.length > 0">
              <caption class="sr-only">Tabella lista file</caption>
              <tr>
                <th colspan="2">Nome File</th>
                <th colspan="2">Primario</th>
                <th colspan="4" style="text-align: center">Tipologia Documento <span _ngcontent-c10=""class="mandatory ">*</span></th>
                <th colspan="2"></th>
              </tr>
              <tr *ngFor="let item of fileUploadList; let index = index">
                <td colspan="2">
                  <p class="file_name">{{item.nomeFile}}</p>
                </td>
                <td colspan="2" style="text-align: center">
                  <input type="radio" name="" title="Imposta come primario" (click)="changePrimary(item.refDocumentale)"
                    [checked]="getPrimary(item.refDocumentale)">
                </td>
                <td colspan="4">
                  <label for="tipo_doc" class="sr-only">Tipologia Documento</label>
                  <select #typeDocSelect id="tipo_doc" class="form-control" (change)="onTypeDocChange($event, item)">
                    <option value="null">Seleziona Tipologia documento</option>
                    <option value="{{item.descrizione}}" *ngFor="let item of tipoDocumentoOption | filterDocumentType: getPrimary(item.refDocumentale) : item">
                      {{item.descrizione}}
                    </option>
                  </select>
                </td>
                <td colspan="2" class="tg-oy1"><span style="text-align: center;color:#0b59a4;cursor: pointer;" class="glyphicon glyphicon-trash"
                    (click)="deleteFile(item.refDocumentale, index)"></span>
                </td>
              </tr>
            </table> -->
          </div>
        </div>
      </div>
      <div class="col-sm-3" style="display: flex; justify-content: end;">
        <app-upload-tool [standard]="true" (onChange)="onSearchChange($event)">
        </app-upload-tool>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-7"></div>
      <div class="col-sm-5" style="text-align: end;">
        <div *ngIf="maxFileSize" class="error-msg" style="margin-top:2%;">
          La dimensione massima dei documenti non può eccedere i {{ maxFileSizeMB }} MB
        </div>
      </div>
    </div>
	</div>

  <div class="uploaded-docs" *ngIf="listaDocumenti.length > 0">
    <!-- <p>Documenti precedentemente caricati</p> -->
    <table class="table-striped table col-xs-12">
      <caption class="sr-only">Tabella lista documenti</caption>
      <tbody>
        <tr>
          <th width="20%">Nome File</th>
          <th>Tipologia Documento</th>
          <th>Primario</th>
        </tr>
        <tr *ngFor="let item of listaDocumenti; let index = index">
          <td>
            <p class="file_name">{{item.nomeFile}}</p>
          </td>
          <td>
            {{item.tipoDocumento.descrizione}}
          </td>
          <td>
            <strong class="color: red">{{item.primary ? "Sì" : "No"}}</strong>
          </td>
        </tr>
      </tbody>
    </table>
  </div>



  <div class="row">
    <p class="col-sm-12 mandatory">
      <em>* Campi obbligatori</em>
    </p>
  </div>
  <div class="row">
    <div class="col-xs-6 col-sm-3">
      <button class="btn btn-outline-secondary btn-block" type="button" (click)="onReset($event)">
        Reset
      </button>
    </div>
    <div class="col-sm-3 col-sm-offset-6 col-xs-6">
      <button class="btn btn-primary btn-block" [disabled]="!checkFormValidity()" type="submit">Inserisci e
        salva</button>
    </div>
  </div>

</form>
